var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWave2 = function SvgWave2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1440 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M0 80V.5c314 50.5 986 61 1440 0V80z"
  })));
};
export default SvgWave2;